(function () {
  if (window.__cascadingVariantOptionsInit) return;
  window.__cascadingVariantOptionsInit = true;

  function getFieldsetPosition(fieldset) {
    const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
    if (!inputs.length) return null;

    return {
      getSelectedValue() {
        const checked = fieldset.querySelector('input:checked');
        return checked ? checked.value : null;
      },
      items: inputs.map((input) => {
        const label = fieldset.querySelector(`label[for="${input.id}"]`);
        return {
          value: input.value,
          isSelected: () => input.checked,
          show() {
            input.style.display = '';
            if (label) label.style.display = '';
          },
          hide() {
            input.style.display = 'none';
            if (label) label.style.display = 'none';
          },
          select() {
            input.checked = true;
          },
          dispatchChange() {
            input.dispatchEvent(new Event('change', { bubbles: true }));
          },
        };
      }),
    };
  }

  function getCustomSelectPosition(customSelect) {
    const select = customSelect.querySelector('select');
    const list = customSelect.querySelector('.custom-select__list');
    if (!select || !list) return null;

    const options = Array.from(select.options);

    return {
      getSelectedValue() {
        return select.value;
      },
      items: options.map((option) => {
        const li = list.querySelector(`.custom-select__option[data-value="${CSS.escape(option.value)}"]`);
        return {
          value: option.value,
          isSelected: () => option.selected,
          show() {
            option.hidden = false;
            if (li) li.style.display = '';
          },
          hide() {
            option.hidden = true;
            if (li) li.style.display = 'none';
          },
          select() {
            select.value = option.value;
            customSelect.updateLabel?.();
          },
          dispatchChange() {
            select.dispatchEvent(new Event('change', { bubbles: true }));
          },
        };
      }),
    };
  }

  function getPositions(variantSelects) {
    const positions = [];

    Array.from(variantSelects.children).forEach((child) => {
      if (child.tagName === 'FIELDSET') {
        const position = getFieldsetPosition(child);
        if (position) positions.push(position);
      } else if (child.tagName === 'DIV' && child.classList.contains('product-form__input--dropdown')) {
        const customSelect = child.querySelector('custom-select');
        if (customSelect) {
          const position = getCustomSelectPosition(customSelect);
          if (position) positions.push(position);
        }
      }
    });

    return positions;
  }

  function applyFiltering(variantSelects, combos) {
    const positions = getPositions(variantSelects);
    if (positions.length < 2) return;

    const selectedValues = positions.map((position) => position.getSelectedValue());
    const corrections = [];

    positions.forEach((position, posIndex) => {
      let fallbackItem = null;
      let selectedIsVisible = false;

      position.items.forEach((item) => {
        const matches = combos.some((combo) => {
          for (let i = 0; i < posIndex; i++) {
            if (selectedValues[i] !== null && combo[i] !== selectedValues[i]) return false;
          }
          return combo[posIndex] === item.value;
        });

        if (matches) {
          item.show();
          if (!fallbackItem) fallbackItem = item;
          if (item.value === selectedValues[posIndex]) selectedIsVisible = true;
        } else {
          item.hide();
        }
      });

      if (!selectedIsVisible && fallbackItem && selectedValues[posIndex] !== null) {
        fallbackItem.select();
        selectedValues[posIndex] = fallbackItem.value;
        corrections.push(fallbackItem);
      }
    });

    // Dispatch change for corrections after all positions have been evaluated,
    // so downstream variant lookups see the fully-corrected selection.
    corrections.forEach((item) => item.dispatchChange());
  }

  function initAll() {
    document.querySelectorAll('variant-selects[data-cascading-options]').forEach((variantSelects) => {
      const dataEl = variantSelects.querySelector('[data-variant-combos]');
      if (!dataEl) return;

      let variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      const combos = variants.map((v) => [v.option1, v.option2, v.option3]);
      applyFiltering(variantSelects, combos);
    });
  }

  const runInit = () => initAll();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInit);
  } else {
    runInit();
  }

  // Dawn's ProductInfo AJAX flow (assets/product-info.js) only publishes
  // PUB_SUB_EVENTS.variantChange when the newly-selected combination resolves
  // to an available variant. When switching to a value that makes the
  // *current* selection in a later position invalid (exactly the case this
  // filter needs to handle), Dawn calls setUnavailable() and returns early
  // WITHOUT publishing that event. So we can't rely on it alone.
  //
  // What Dawn always does, success or failure, is swap in a brand new
  // <variant-selects> node next to the old one (assets/global.js
  // HTMLUpdateUtility.viewTransition inserts the new node, hides the old one,
  // then removes it ~500ms later). Observing the DOM for that insertion is a
  // reliable, implementation-agnostic hook that fires in every case.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      setTimeout(runInit, 0);
    });
  }

  let mutationDebounce;
  const observer = new MutationObserver((mutations) => {
    const relevant = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some(
        (node) =>
          node.nodeType === 1 &&
          (node.matches?.('variant-selects[data-cascading-options]') ||
            node.querySelector?.('variant-selects[data-cascading-options]'))
      )
    );
    if (!relevant) return;
    clearTimeout(mutationDebounce);
    mutationDebounce = setTimeout(runInit, 0);
  });

  const startObserving = () => observer.observe(document.body, { childList: true, subtree: true });
  if (document.body) {
    startObserving();
  } else {
    document.addEventListener('DOMContentLoaded', startObserving);
  }
})();
